"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BitbucketSourceIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m8.85 6.74-4.56 4.55a1 1 0 0 0 0 1.42l4.56 4.55a1.05 1.05 0 0 0 1.49-1.49L6.57 12l3.78-3.77a1.05 1.05 0 0 0 0-1.49 1.05 1.05 0 0 0-1.49 0m4.8 0a1.05 1.05 0 0 0 0 1.49L17.43 12l-3.78 3.77a1.05 1.05 0 0 0 0 1.49 1.05 1.05 0 0 0 1.49 0l4.56-4.55a1 1 0 0 0 0-1.41l-4.56-4.55a1.05 1.05 0 0 0-.74-.31 1.05 1.05 0 0 0-.74.31"/></svg>`
}, props));
BitbucketSourceIcon.displayName = 'BitbucketSourceIcon';
var _default = exports.default = BitbucketSourceIcon;